import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PAGE_LABELS = {
  '/admin/dashboard': 'Dashboard',
  '/admin/attendance-validation': 'Pointages',
  '/admin/history': 'Historique',
  '/admin/employees': 'Employes',
  '/admin/schedules': 'Plannings',
  '/admin/absences': 'Absences',
  '/admin/costs': 'Couts personnel',
  '/admin/stats': 'Statistiques',
  '/admin/overtime-requests': 'Hors planning',
  '/admin/messages': 'Messages',
  '/admin/regularisations': 'Regularisations',
  '/admin/validation-month': 'Validation mois',
  '/admin/responsable-leaves': 'Conges responsable',
  '/admin/my-payslips': 'Bulletin de salaire',
  '/admin/comptables': 'Comptables',
  '/admin/responsables': 'Responsables',
  '/admin/stores': 'Magasins',
  '/admin/gerants': 'Gerants',
  '/admin/sessions': 'Connexions',
  '/admin/settings': 'Parametres',
  '/comptable': 'Portail comptable',
  '/employee': 'Espace employe',
};

const usePageTracking = () => {
  const location = useLocation();
  const lastTrackedRef = useRef('');

  useEffect(() => {
    const path = location.pathname;
    // Avoid tracking the same page twice in a row
    if (path === lastTrackedRef.current) return;
    lastTrackedRef.current = path;

    const token = localStorage.getItem('token');
    if (!token) return;

    const pageLabel = PAGE_LABELS[path] || path;

    // Fire and forget — don't block the UI
    axios.post(`${API}/track/page-visit`, { page: pageLabel }, {
      headers: { Authorization: `Bearer ${token}` }
    }).catch(() => {});
  }, [location.pathname]);
};

export default usePageTracking;
